var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "delete-confirm-mask",
      },
      [
        _c("div", { staticClass: "delete-confirm-container" }, [
          _c("div", { staticClass: "delete-confirm-content" }, [
            _c("h3", [_vm._v(_vm._s(_vm.title))]),
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c("el-button", { on: { click: _vm.handleCancel } }, [
                  _vm._v("取消"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v("确定")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }